import logger from '../log';

import HLS from 'hls-parser';

import PlaybackConfig from '../config/PlaybackConfig';
import { PlayType } from '../common/constants';
import stripBitrates from './stripBitrates';
import { Bitrates } from '../config/interfaces';
import coerceBitrates from '../bitrates/coerceBitrates';
import { isPositive } from '../common/utils/numbers';
import { monitorManifest } from '../interceptor/objectId/HlsObjectIdMapper';

const log = logger.getLogger(__filename);

function getBitrates(playback: PlaybackConfig, playType: PlayType): Bitrates {
  // The play type should be known by now. If not, we just use the LIVE bitrates.
  const bitrates = playType === PlayType.VOD ? playback.vod : playback.live;
  return coerceBitrates(bitrates);
}

export default function filterHlsBitrates(
  // SRV-3982 - url is needed by the `monitorManifest function.
  url: string,
  manifestText: string,
  playbackConfig: PlaybackConfig,
  playType: PlayType
): string {
  try {
    const playlist = HLS.parse(manifestText);
    // TODO - Should this live somewhere else as it's not tied to modification of manifests?
    // It's here because I don't think it's wise to duplicate parsing of the manifest (for performance sake).
    monitorManifest(url, playlist);

    if (playlist.isMasterPlaylist) {
      const { minVideoBitrate, maxVideoBitrate } = getBitrates(
        playbackConfig,
        playType
      );
      if (isPositive(minVideoBitrate) || isPositive(maxVideoBitrate)) {
        // we know that these are at least 0 because of coerceBitrates
        // so cast is safe
        const out = stripBitrates(
          minVideoBitrate as number,
          maxVideoBitrate as number,
          // we can cast because we checked isMasterPlaylist above
          playlist as HLS.types.MasterPlaylist
        );
        return HLS.stringify(out);
      }
      return manifestText;
    } else {
      return manifestText;
    }
  } catch (e) {
    log.debug('Failed to filter HLS Bitrates: ', e);
    return manifestText;
  }
}
